import React from "react";
import RoleFilterForm from "./RoleFilterForm";

const RoleFilter: React.FC = () => {
  return <RoleFilterForm />;
};

export default RoleFilter;
